import { OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ManagedClient } from '../../shared/models/managed-client';
import { ClientService } from '../../shared/services/client.service';
import { Location } from "@angular/common";
import { ReportService } from "../../reports/services/report.service";
import { AlertService } from 'app/shared/services/alert.service';
import { TabsetComponent } from 'ng-mdb-pro/pro';
import { ShoppingService } from 'app/shared/services/shopping.service';
import { AssessmentAssignerService } from '../services/assessment-assigner.service';
import { AuthService } from 'app/login/services/auth.service';
import { AssignmentService } from 'app/shared/services/assignment.service';
var ClientEditComponent = /** @class */ (function () {
    function ClientEditComponent(_clientService, router, location, route, alertService, reportService, authService, shoppingService, assessmentAssignerService, assignmentService) {
        this._clientService = _clientService;
        this.router = router;
        this.location = location;
        this.route = route;
        this.alertService = alertService;
        this.reportService = reportService;
        this.authService = authService;
        this.shoppingService = shoppingService;
        this.assessmentAssignerService = assessmentAssignerService;
        this.assignmentService = assignmentService;
        this._reportsByAssignment = {};
        this._client = new ManagedClient();
        this._clientToSave = new ManagedClient();
        this.loadedClient = false;
        this.clientShareLink = window.location.href;
        this.hasActiveSubscription = false;
    }
    ClientEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.authService.getLoginState().subscribe(function (loginState) {
            if (loginState && loginState.user) {
                _this.hasActiveSubscription = loginState.user.hasActiveSubscription();
            }
            else {
                _this.hasActiveSubscription = false;
            }
        });
        // we are skipping the whole switchMap thingy until we figure out
        // more on how to use it... for now we are just trying to port the code
        // from angularjs (1.X)
        // TODO: stephen figure out how to do the switchMap to cut down on multiple http requests.
        this.route.params.subscribe(function (params) {
            var clientId = params['id'];
            if (!clientId || typeof clientId !== "string") {
                _this.router.navigate(['../']);
                return;
            }
            _this._clientService.getClient(clientId)
                .then(function (client) {
                console.log("loaded client is ", client);
                _this._client = client;
                _this._clientToSave = Object.assign(new ManagedClient(), client); // copy over relevant data
                _this.loadedClient = true;
                // if we have no assignments we need to make sure we go to the tab for setting assignments.
                _this._reportsByAssignment = {};
                // TODO: stephen I'm not sure I like the way this is implemented.
                return Promise.all(client.assignments.map(function (a) { return _this.reportService.getReportsForAssignment(a).then(function (reports) {
                    _this._reportsByAssignment[a.Id] = reports.map(function (r) { return Object.assign(r, { IsComplete: a.IsComplete, hasMetRequirements: true }); });
                }); }))
                    .then(function (results) {
                    return client;
                });
            })
                .then(function (client) {
                // since the tabs haven't rendered yet... we need to wait for them to render now that the
                // client has loaded.
                if (client.hasNoAssignments()) {
                    setTimeout(function () {
                        if (_this.staticTabs) {
                            _this.staticTabs.tabs[1].active = true;
                        }
                    }, 250);
                }
            })
                .catch(function (error) {
                _this.alertService.error("Failed to load client from server. Please check your internet connection and reload the page");
                console.error(error);
                // TODO: stephen handle when client is not
                // found
            });
        });
    };
    ClientEditComponent.prototype.goBack = function () {
        this.location.back();
    };
    Object.defineProperty(ClientEditComponent.prototype, "assignments", {
        get: function () {
            return this._client.assignments;
        },
        enumerable: true,
        configurable: true
    });
    ClientEditComponent.prototype.getReportsForAssignment = function (assignment) {
        if (this._reportsByAssignment[assignment.Id]) {
            return this._reportsByAssignment[assignment.Id];
        }
        return [];
    };
    ClientEditComponent.prototype.setNewUser = function (user) {
        this._newAssignedUser = user;
    };
    ClientEditComponent.prototype.updateClientUser = function (isValid) {
        var _this = this;
        if (!isValid) {
            this.alertService.error("You must fill in all required fields");
            return;
        }
        // need to go through and validate the client
        if (this._newAssignedUser) {
            this._clientToSave.user = this._newAssignedUser;
        }
        // let errors = this._clientService.validateClient(this._clientToSave);
        this.isSavingClient = true;
        this._clientService.saveClient(this._clientToSave).then(function (result) {
            _this.isSavingClient = false;
            _this._client.lastName = _this._clientToSave.lastName;
            _this._client.firstName = _this._clientToSave.firstName;
            _this._client.email = _this._clientToSave.email;
            _this._client.user = _this._clientToSave.user;
            _this.alertService.success("Client information was updated");
        })
            .catch(function (error) {
            _this.isSavingClient = false;
            _this.alertService.error("Failed to update client information.  Try again or contact support");
            console.error(error);
        });
    };
    Object.defineProperty(ClientEditComponent.prototype, "client", {
        get: function () {
            return this._client;
        },
        set: function (v) {
            this._client = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClientEditComponent.prototype, "clientToSave", {
        get: function () {
            return this._clientToSave;
        },
        set: function (v) {
            this._clientToSave = v;
        },
        enumerable: true,
        configurable: true
    });
    return ClientEditComponent;
}());
export { ClientEditComponent };



// WEBPACK FOOTER //
// ./src/app/admin/client-edit/client-edit.component.ts.pre-build-optimizer.js